import tripLogo from "../../assets/img/tripLogo.png"
import Img1 from "../../assets/img/1.jpg";
import {Link} from "react-router-dom";

const TripLogin = () => {

    return (
        <div
            className="h-screen flex flex-col justify-center items-center bg-gray-100 tripBackgroud">
            <div className="flex items-center mb-2">
              <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2" />
              <span className="font-Beiruti text-[#265069] text-[20px]">
                چت بات گردشگری
              </span>
              </div>
            <div
                className="bg-[#fdfdfd] w-[85%] lg:w-[95%] max-w-[450px] rounded-xl p-6 shadow-lg flex flex-col items-start relative">

                <img src={Img1} className="w-[70%] mx-auto" alt="logo"/>
                <p
                    className="font-Beiruti text-[#f8b323] text-[30px] text-center block mx-auto font-semibold">
                    به دنیای سفر خوش اومدی !
                </p>
                <p className="font-IRANYekanMedium text-black text-[14px] text-center">
                چت‌باتی که کمکت می‌کنه مقصدی پیدا کنی که واقعاً با سلیقه‌ت جور باشه! فقط کافیه به چند تا سوال جواب بدی تا سفر مورد علاقت رو از همین جا شروع کنی !                    </p>
              
                <Link
                
                to="/tripFirstStep"   className="text-center bg-[#0b94ca] w-full font-IRANYekanExtra text-white px-4 py-2 rounded-lg mt-4 hover:bg-[#f8b323]">
                
                  
                        شروع !
                 

               
                </Link>
                
            </div>

        </div>
    )

}

export default TripLogin;